export default __webpack_public_path__ + "static/Web-camera-amazon-main-diagram-DE-1-86f44e43f5613b9bffb1ca0020a53218.webp";